import login_image from "../image/bg1.png";
import med_logo from "../image/MEDDAILY-LOGO-inverted.png";
// import med_logo from "../image/logo.png";
import "../css/login.css";
import { Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import play_app_icon from "../image/catalog/app.png";
import axios from "axios";
import { useState } from "react";
import Snackbar from '@mui/material/Snackbar';

const Login = () => {
  const navigate = useNavigate();
  const [isMessage, setIsMessage] = useState(null);

  const [loginData, setLoginData] = useState({
    phone: "",
    password: "",
  });

  const handleChenge = (e) => {
    const { id, value } = e.target;
    setLoginData({
      ...loginData,
      [id]: value,
    });
  };

  // const onSubmitHandler = () => {
  //   axios.post("PASTE YOUR API HERE", {}).then((response) => {
  //     const response1 = response;
  //     localStorage.setItem("stringify", JSON.stringify(response1));
  //     localStorage.setItem("Mytoken", response1.data.token);
  //   });
  // };

  const handleLogin = (e) => {

    axios
      .post("http://api.meddaily.in/retailer_login", loginData)

      .then(res => {
        if (res?.data?.status) {
          sessionStorage.setItem("key", JSON.stringify(res.data));
          sessionStorage.setItem("token", res.data.token);
          navigate('/home');
        } else {
          alert('Invalid Credentials!');
          // navigate('/login')
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      {/* <Navbar /> */}
      <div className="login-body">

        <div className="big-img-div">
          <img src={login_image} alt="login" className="img-login" />
        </div>

        <div className="form-div-1">

          <Link style={{ textDecoration: "none" }} to="/">
            <img src={med_logo} alt="company_logo"  width="250" height="100" />
          </Link>

          <div className="form">
            <Typography variant="h4" mt={8}>
              {" "}
              <strong>Log In</strong>
            </Typography>
            <Typography color="#2D3748" mt={2} mb={4}>
              {" "}
              For Retailers.
            </Typography>
            <div className="div-for-data">
              <div>
                <Typography>
                  <strong>Phone Number</strong>
                </Typography>
                <input
                  placeholder="Phone Number"
                  className="form-data"
                  id="phone"
                  onChange={handleChenge}
                  value={loginData.phone}
                  name="phone"
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>Password</strong>
                </Typography>
                <input placeholder="Password" className="form-data"
                  id="password"
                  value={loginData.password}
                  name="password"
                  type="password"
                  onChange={handleChenge}
                ></input>
              </div>
            </div>
            <div className="create-acc-div">
              <button className="register-button" onClick={handleLogin}>
                Log In
              </button>
              <Typography mt={2} mb={6}>
                {" "}
                Don’t have an account? <Link to="/retailer_signup">Sign up</Link>
              </Typography>
            </div>

          </div>
          <img src={play_app_icon} alt="logo" className="play_app_icon" />
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Login;
